import React from 'react';

export const IconCompany = () => (
    <svg width='24' height='24' xmlns='http://www.w3.org/2000/svg'>
        <path
            fillRule='evenodd'
            clipRule='evenodd'
            d='M12 23a11 11 0 100-22 11 11 0 000 22zM9 12h.53c.73.61 1.57 1 2.47 1 .9 0 1.74-.39 2.47-1H15a3 3 0 013 3v1.16a2.5 2.5 0 01-.8 1.93 7.97 7.97 0 01-3.47 1.72L13 14l-1-1-1 1-.73 5.81a7.97 7.97 0 01-3.46-1.72A2.5 2.5 0 016 16.16V15a3 3 0 013-3zm6-5c0 1.66-1.34 4-3 4S9 8.66 9 7a3 3 0 116 0z'
            fill='currentColor'
        />
    </svg>
);
